import { render } from "./CollectedSamplesOrders.vue?vue&type=template&id=95cee236"
import script from "./CollectedSamplesOrders.vue?vue&type=script&lang=js"
export * from "./CollectedSamplesOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/CollectedSamplesOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95cee236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95cee236', __exports__)) {
    console.log('reload')
    api.reload('95cee236', __exports__)
  }
  
  module.hot.accept("./CollectedSamplesOrders.vue?vue&type=template&id=95cee236", () => {
    console.log('re-render')
    api.rerender('95cee236', render)
  })

}


export default __exports__